import { select } from 'redux-saga/effects';
import { partnerIdSelector } from '../selectors/partner';

export function* getPartnerId() {
    const partnerId: string | undefined = yield select(partnerIdSelector);

    return partnerId;
}
